export enum ChannelCostType {
    NotSetted = 0,
    FixedPrice = 1,
    MonthlyPrice = 2,
    LeadPrice = 3
}
